export function renderComponent(component: React.ReactNode | React.ComponentType<any>, props?: any): React.ReactNode
{
    // if (!component || typeof component !== "object" || "props" in (component as object))
        return component as React.ReactNode;

    // const Component: any = component;
    // console.log("Rendering icon...");

    // return <Component {...props} />;
}
